import { Icon, IconProps } from "@chakra-ui/react";

const Tick = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 15 12" {...props}>
      <path
        d="M14.5833 1.175L4.58333 11.175L0 6.59167L1.175 5.41667L4.58333 8.81667L13.4083 0L14.5833 1.175Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default Tick;
